import { record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import Linkify from 'react-linkify';
import { keyById } from '@mews/fp';
import { LocalizedText } from '@mews/framework';
import { NewTabLink } from '../../navigation';
import { LinkDefinition, LinkDefinitionNew } from './types';
import { matchDecorator } from './utils';

const LinkComponent = (decoratedHref: string, decoratedText: string, key: number) => (
    <NewTabLink url={decoratedHref} key={key}>
        {decoratedText}
    </NewTabLink>
);

interface TextWithLinksProps {
    text: string;
    textKey?: never;
    links: LinkDefinition[];
}

/**
 * Replaces placeholders in string with link components.
 * @param props
 * @param props.text - Text with placeholders. Example: 'Click {target}!'
 * @param props.links - Links to be inserted into placeholders
 * @deprecated Use LocalizedText with JSX substitutes instead
 */
export const TextWithLinks = ({ text, textKey, links }: TextWithLinksProps | TextWithLinksPropsNew) =>
    textKey ? (
        <TextWithLinksNew textKey={textKey} links={links} />
    ) : (
        <Linkify matchDecorator={matchDecorator(links)} componentDecorator={LinkComponent}>
            {text}
        </Linkify>
    );

interface TextWithLinksPropsNew {
    text?: never;
    textKey: Mews.TextKey;
    links: LinkDefinitionNew[];
}

const TextWithLinksNew = ({ textKey, links }: TextWithLinksPropsNew) => {
    const linkComponents = pipe(
        links,
        keyById,
        record.map((link: LinkDefinitionNew) => (
            <NewTabLink url={link.url}>
                <LocalizedText textKey={link.textKey} />
            </NewTabLink>
        ))
    );

    return <LocalizedText textKey={textKey} substitutes={linkComponents} />;
};
